// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__hvU5D","wrapperContent":"styles_wrapperContent__SpCVM"};